/**
 * Live BUTTONS explore page.
 *
 * Polls GET /api/stream/buttons/live every 10s while this page is mounted. That request is what starts
 * the server's Timescale poll; leaving the page stops it. BTN_* is in no parquet and the boat stream does
 * not subscribe to it, so that endpoint is the only source of this data - see liveButtons.js.
 */
import ButtonsReportSection from "../../../../components/reports/ButtonsReportSection";

export default function LiveButtonsPage(props: Record<string, unknown>) {
  return <ButtonsReportSection {...props} variant="fleet" live />;
}
